export default __webpack_public_path__ + "static/media/BgPalent.706dcac8.png";